import { render, staticRenderFns } from "./TranscriptCard.vue?vue&type=template&id=e2a5501e&"
import script from "./TranscriptCard.vue?vue&type=script&lang=js&"
export * from "./TranscriptCard.vue?vue&type=script&lang=js&"
import style0 from "./TranscriptCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../code/tibava/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports